import { render, staticRenderFns } from "./WebRtcLivestreamRecording.vue?vue&type=template&id=cb39b844&scoped=true"
import script from "./WebRtcLivestreamRecording.vue?vue&type=script&lang=js"
export * from "./WebRtcLivestreamRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb39b844",
  null
  
)

export default component.exports